export default {
  ADULT: 'ADT',
  SENIOR: 'SRC',
  CHILD: 'CHD',
  YOUTH: 'YTH',
  INFANT: 'INF',
  INFANTWITHSEAT: 'INS',
};
export const PassengerTypeEnum = {
  None: 0,
  Adult: 1,
  Child: 2,
  Infant: 3,
  MilitaryStaff: 4,
  Senior: 5,
  Youth: 6,
  InfantWithSeat: 7,
};
